import { render, staticRenderFns } from "./ModifyMessageTemplate.vue?vue&type=template&id=1f5390a1&scoped=true&"
import script from "./ModifyMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./ModifyMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5390a1",
  null
  
)

export default component.exports